import React, { useRef, useEffect } from "react";

const SortCodeInput = React.forwardRef(
	({ label, required, error, onChange, value = [], name, onBlur, id }, ref) => {
		const inputRefs = [useRef(), useRef(), useRef()];

		// Auto-focus to next input when 2 digits are entered
		const handleInputChange = (index, inputValue) => {
			const newValues = [...(value || [])];
			newValues[index] = inputValue;

			// Call the parent onChange
			if (onChange) {
				onChange(newValues);
			}

			// Auto-focus to next input if 2 digits entered
			if (inputValue.length === 2 && index < 2) {
				inputRefs[index + 1].current?.focus();
			}
		};

		// Handle backspace to go to previous input
		const handleKeyDown = (index, e) => {
			if (e.key === "Backspace" && e.target.value === "" && index > 0) {
				inputRefs[index - 1].current?.focus();
			}
		};

		return (
			<div className="form-field">
				{label && (
					<label className="field-label">
						{label}
						{required && <span className="required">*</span>}
					</label>
				)}

				<div className="input-area sort-code-container">
					{Array.from({ length: 3 }).map((_, idx) => (
						<input
							key={idx}
							ref={inputRefs[idx]}
							type="text"
							value={value[idx] || ""}
							onChange={(e) => handleInputChange(idx, e.target.value)}
							onKeyDown={(e) => handleKeyDown(idx, e)}
							onBlur={onBlur}
							maxLength={2}
							className={`form-control sort-code-input ${error ? "error" : ""}`}
							style={{
								width: "60px",
								textAlign: "center",
								marginRight: idx < 2 ? "8px" : "0",
							}}
						/>
					))}
					<small className="sort-code-description">
						The 6-digit number usually found on the front of your debit card
					</small>
				</div>

				{error && <div className="field__error">{error.message}</div>}
			</div>
		);
	}
);

export default SortCodeInput;
